import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-new-partner',
  templateUrl: './new-partner.component.html',
  styleUrls: ['./new-partner.component.scss']
})
export class NewPartnerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
